import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IOpposingCardDetailsFormMeta {
  pan: FormInputMeta;
  expirationDate: FormInputMeta;
  cardholder: FormInputMeta;
  incidentDate: FormInputMeta;
  effectiveDateOfOpposition: FormInputMeta;
  reasonForTheIncident: FormInputMeta;
  authorizationResponseCode: FormInputMeta;
  action: FormInputMeta;
  memo: FormInputMeta;

  schema: any;
}

const opposingCardDetailsFormMeta = {} as IOpposingCardDetailsFormMeta;

opposingCardDetailsFormMeta.pan = {
  name: "pan",
  type: "text",
  label: "PAN",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

opposingCardDetailsFormMeta.expirationDate = {
  name: "expirationDate",
  type: "date",
  label: "Date Expiration",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

opposingCardDetailsFormMeta.cardholder = {
  name: "cardholder",
  type: "text",
  label: "Porteur",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

opposingCardDetailsFormMeta.incidentDate = {
  name: "incidentDate",
  type: "date",
  label: "Date incident",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

opposingCardDetailsFormMeta.effectiveDateOfOpposition = {
  name: "effectiveDateOfOpposition",
  type: "date",
  label: "Date d'opposition effective",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

opposingCardDetailsFormMeta.reasonForTheIncident = {
  name: "reasonForTheIncident",
  type: "select",
  options: [
    { value: "1", label: "Raison 1" },
    { value: "2", label: "Raison 2" },
    { value: "3", label: "Raison 3" },
  ],
  label: "Raison de l'incident",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

opposingCardDetailsFormMeta.authorizationResponseCode = {
  name: "authorizationResponseCode",
  type: "select",
  options: [
    { value: "1", label: "Code 1" },
    { value: "2", label: "Code 2" },
    { value: "3", label: "Code 3" },
  ],
  label: "Code réponse autorisation",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

opposingCardDetailsFormMeta.action = {
  name: "action",
  type: "select",
  options: [
    { value: "1", label: "Action 1" },
    { value: "2", label: "Action 2" },
    { value: "3", label: "Action 3" },
  ],
  label: "Action",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

opposingCardDetailsFormMeta.memo = {
  name: "memo",
  type: "textarea",
  label: "Mémo",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

opposingCardDetailsFormMeta.schema = yup.object().shape(getValidationSchema(opposingCardDetailsFormMeta));

export default opposingCardDetailsFormMeta;